// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"76":"0f92bf18","113":"5b968979","142":"a6c474e1","143":"72f26e8d","210":"19d20647","358":"10e83d69","385":"0a8af5fc","438":"24be9ca9","515":"e9bb3953","553":"4f4d2a88","821":"06397293","894":"04f26f6d"}[chunkId] + ".chunk.js";
};